import { axiosInstance } from 'src/services/axiosInstance'
import { REACT_ACTIONS } from '../constants'

export const PostQuery = async (tagCode: any) => {
	const { data } = await axiosInstance.get(`${REACT_ACTIONS}tag_code/?tag_code=${tagCode}`)
	return data
}
